export default {
    // 流程启用接口
    submitLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/submitLeaveBill', params, response);
    },
    // 查询我的请假流程
    queryMyLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryMyLeaveBill', params, response);
    },
    // 查询流程信息
    queryLeaveBillByCode(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryLeaveBillByCode', params, response);
    },
    // 查询流程图状态
    queryLeaveBillPicByCode(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryLeaveBillPicByCode', params, response);
    },
    // 根据流程编号查询流程状态
    queryProcessState(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryProcessState', params, response);
    }
};
